<template>
  <a :href="`tel:${hrefNumber}`"
     :aria-label="ariaLabel"
     v-bind="$attrs"
     v-on="$listeners"
     @click="makePhoneCall"
     v-html="displayNumber">
  </a>
</template>

<script>
import { RegexConstants } from '../../../constants'

import ExternalApp from '../../../utility/externalAppUtil'

export default {
  name: 'phone-number',

  props: {
    /**
     * The phone number. Required.
     */
    number: {
      type: [Number, String],
      default: '',
      validator (value) {
        if (!value) {
          return true
        }

        return value.toString() ? value.toString().replace(/[^0-9]/g, '').length === 10 : false
      }
    },

    /**
     * The name of the page or element the phone number is implemented on. This is used to populate an analytics event.
     */
    locatedOn: {
      type: [String],
      required: true
    }
  },

  computed: {
    ariaLabel () {
      return this.hrefNumber.replace(/^(\d{1})(\d{1})(\d{1})(\d{1})(\d{1})(\d{1})(\d{1})(\d{1})(\d{1})(\d{1})$/, '$1 $2 $3. $4 $5 $6. $7 $8 $9 $10.')
    },

    displayNumber () {
      return this.hrefNumber.replace(/^(\d{3})(\d{3})(\d{4})$/, '($1) $2-$3')
    },

    hrefNumber () {
      return this.number.replace(RegexConstants.phoneNumberFormatting, '')
    }
  },

  methods: {
    makePhoneCall () {
      ExternalApp.phoneCall(this.number, this.locatedOn)
    }
  }
}
</script>
